/********************************************************************
 * Project: WDCK（2021）
 * Class: ScreenMode
 * ----------------------------------------
 * <summary>
 * ScreenMode
 * </summary>
 * <history>
 *      ThaiTV     2021/07/16      Create
 * </history>
 ********************************************************************/
 export enum ScreenMode {
    Edit = 'edit',
    Add = 'add',
    View = 'view',
    Confirm = 'confirm',
}
